const types = {
    SAVE_MENUAUTH: 'menu/SAVE_MENUAUTH',
};

export const saveMenuAuth = params => ({
    type: types.SAVE_MENUAUTH,
    params,
});

const initState = {
    menuAuth: {},
};

const menuReducer = (state = initState, actions) => {
    switch(actions.type) {
        case types.SAVE_MENUAUTH:
            return { menuAuth: { ...actions.params } };
        default:
            return state;
    }
}

export default menuReducer;


// WEBPACK FOOTER //
// ./src/actions/menuActions.js